@if (prompt.visible()) {
  <div class="login-required-backdrop" (click)="close()"></div>

  <div
    class="modal d-block login-required-modal"
    tabindex="-1"
    role="dialog"
    aria-modal="true"
    aria-labelledby="loginRequiredTitle"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content border-0 rounded-4 shadow">
        <div class="modal-header border-0 pb-0">
          <h5 class="modal-title fw-semibold" id="loginRequiredTitle">
            {{ 'loginRequired.title' | translate }}
          </h5>
          <button
            type="button"
            class="btn-close"
            [attr.aria-label]="'common.close' | translate"
            (click)="close()"
          ></button>
        </div>

        <div class="modal-body pt-2">
          <div class="d-flex align-items-start gap-3">
            <i class="bi bi-person-lock fs-3 text-primary"></i>
            <p class="text-muted mb-0">
              @if (prompt.reason() === 'cart') {
                {{ 'loginRequired.cartMessage' | translate }}
              } @else {
                {{ 'loginRequired.genericMessage' | translate }}
              }
            </p>
          </div>
        </div>

        <div class="modal-footer border-0 pt-0 flex-wrap gap-2">
          <button type="button" class="btn btn-outline-secondary btn-sm" (click)="close()">
            {{ 'common.cancel' | translate }}
          </button>
          <button type="button" class="btn btn-outline-primary btn-sm" (click)="goToRegister()">
            {{ 'loginRequired.register' | translate }}
          </button>
          <button type="button" class="btn btn-primary btn-sm" (click)="goToLogin()">
            {{ 'loginRequired.login' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
}
